//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {REPORT_SPECIES_TYPES} from '~/plugins/constants';

export default {
  props: {
    species: {
      type: Object,
      default: () => {},
    },
    canDelete: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    open: false,
    details: false,
    REPORT_SPECIES_TYPES,
  }),
  computed: {
    color() {
      switch (this.species.type) {
        case 'Sown':
          return '#329C36';
        case 'Spontaneous':
          return '#705EDD';
        case 'Present before':
          return '#BC7D5E';
        default:
          return '#eee';
      }
    },
  },
};
